export default class TabContainer {
	constructor(tabsContainer) {
		if (!tabsContainer) return;
		this.tabsContainer = tabsContainer;
		this.navigation = this.tabsContainer.querySelector('.tab-list');
		this.selectedTab = '';
		this.visibleClass = 'tab-content--is-visible';
		this.activeTabClass = 'tab-link--is-active';
		this.getInitalSelected();
		this.switchListener();
	}

	getInitalSelected() {
		this.selectedTab = this.getSubstring(
			this.navigation
				.querySelector(`.${this.activeTabClass} a`)
				.getAttribute('href'),
		);
		this.switchTabs();
	}

	switchListener() {
		this.navigation.addEventListener('click', e => {
			this.anchorCondition(e);
		});
	}

	anchorCondition(e) {
		const anchor = e.target.closest('a');
		if (anchor) {
			e.preventDefault();
			this.triggerSwitch(this.getSubstring(e.target.hash));
		}
	}

	triggerSwitch(selectedId) {
		if (selectedId !== this.selectedTab) {
			this.selectedTab = selectedId;
			this.switchTabs();
		}
	}

	switchTabs() {
		this.deactivateAllTabs();
		this.hideAllContent();
		this.makeTabActive();
		this.makeContentVisible();
	}

	deactivateAllTabs() {
		const activeNavItem = this.navigation.querySelector(
			`.${this.activeTabClass}`,
		);
		if (activeNavItem) {
			activeNavItem.classList.remove(this.activeTabClass);
			this.setAria(activeNavItem, 'selected', 'false');
		}
	}

	hideAllContent() {
		const visibleContent = this.tabsContainer.querySelector(
			`.tab-content.${this.visibleClass}`,
		);
		if (visibleContent) {
			visibleContent.classList.remove(this.visibleClass);
			this.setAria(visibleContent, 'hidden', 'true');
		}
	}

	makeTabActive() {
		try {
			const parentListItem = this.navigation.querySelector(
				`a[href="#${this.selectedTab}"]`,
			).parentNode;
			parentListItem.classList.add(this.activeTabClass);
			this.setAria(parentListItem, 'selected', 'true');
		} catch (err) {
			throw new Error(err);
		}
	}

	makeContentVisible() {
		const visibleContentElem = this.tabsContainer.querySelector(
			`.tab-content[data-target="${this.selectedTab}"]`,
		);
		if (visibleContentElem) {
			visibleContentElem.classList.add(this.visibleClass);
			this.setAria(visibleContentElem, 'hidden', 'false');
		} else {
			throw new Error(`No matching tab content for '${this.selectedTab}'`);
		}
	}

	getSubstring(id) {
		return id.substring(1);
	}

	setAria(element, ariaType, value) {
		return element.setAttribute(`aria-${ariaType}`, value);
	}
}
